export const getQuillEditorToolPopupPosition = (quillRef, containerRef, quillSelection) => {
  const bounds = quillRef.getBounds(quillSelection.index, quillSelection.length);
  return {
    getBoundingClientRect: () => {
      const container = quillRef.container.getBoundingClientRect();
      return {
        x: container.left,
        y: bounds.top + container.top,
        top: bounds.top + container.top,
        bottom: bounds.bottom + container.top,
        left: container.left,
        right: bounds.width + container.left,
        width: bounds.width,
        height: bounds.height,
      };
    },
    isVirtual: true,
    clientWidth: bounds.width,
    clientHeight: bounds.height,
    contextElement: containerRef,
  }
}